import { Component, OnInit, ViewChild } from '@angular/core';
import { Apiservice } from '../../../services/api.service';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { DxChartComponent } from 'devextreme-angular/ui/chart';


@Component({
  selector: 'app-crm-line-chart-statistiche',
  templateUrl: './crm-line-chart-statistiche.component.html',
  styleUrls: ['./crm-line-chart-statistiche.component.css']
})
export class CrmLineChartStatisticheComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart!: DxChartComponent;

  public heightCharts: number = 260
  public acquiredCostumer: { [key: string]: any }[] = [];
  public currentChartType: string = 'line';
  private moment = require('moment')
  public generalInfo: { [key: string]: any } = {
    trend: 0,
    totalNrProcedure: 0,
    anno: this.moment().year()
  }
  private mesi: number[] = [
    (this.moment().month() + 1),
    (this.moment().month() + 1) - 1,
    (this.moment().month() + 1) - 2,]
  activeButton: number | null = null;

  constructor(private apiService: Apiservice) { }

  ngOnInit() {
    this.getAcquiredCostumer();
  }

  async getAcquiredCostumer() {
    await this.apiService
      .GetApiRest('clientiacquisitiultimitremesi').then((resp: { [key: string]: any }) => {
        const grouped = new Set()
        if (resp.items) this.acquiredCostumer = resp.items.map((obj) => {
          grouped.add(obj.Mese)
          const nomeMese = this.moment()
            .locale('it')
            .month(obj.Mese - 1)
            .format('MMMM');

          obj['desMese'] = nomeMese.charAt(0).toUpperCase() + nomeMese.slice(1);

          return obj
        })
        const now = this.moment().locale('it');
        const annoCorrente = now.year();
        if (this.acquiredCostumer.some((x) => x.Anno !== annoCorrente)) this.generalInfo.anno += ` / ${this.acquiredCostumer.find((x) => x.Anno !== annoCorrente).Anno}`
        this.mesi.forEach((mese) => {
          if (!grouped.has(mese)) {
            const nomeMese = this.capitalizeFirstLetter(now.month(mese - 1).format('MMMM'));
            const existsAfterCurrentYear = this.acquiredCostumer.some((x) => x.Anno < annoCorrente);
            const nuovoElemento = {
              Mese: mese,
              nrProcedure: 0,
              desMese: nomeMese,
              Anno: annoCorrente
            };
            if (existsAfterCurrentYear) {
              this.acquiredCostumer.push(nuovoElemento);
            } else {
              this.acquiredCostumer.unshift(nuovoElemento);
            }
          }

        })
        if (resp.trend) this.generalInfo.trend = resp.trend
        console.log('Dati ricevuti clienti acquisiti:', this.acquiredCostumer);
        if (this.acquiredCostumer) {
          this.generalInfo.totalNrProcedure = this.acquiredCostumer.reduce(
            (acc: number, item: any) => acc + (item.nrProcedure || 0),
            0
          );
        }
      }).catch((err) => {
        console.error('Errore nel caricamento dei dati dei clienti acquisiti:', err);
        this.acquiredCostumer = [];
        this.generalInfo.totalNrProcedure = 0;
      });
  }





  changeChartType(type: string) {
    this.currentChartType = type;

    if (type === 'bar') this.activeButton = 1;
    else if (type === 'line') this.activeButton = 2;
    else if (type === 'pie') this.activeButton = 3;
    console.log('tipo di grafico avviato', type);
  }

  //Generazione ed Esportazione del Pdf

  //   generatePdf() {
  //     setTimeout(() => {
  //         const data = document.getElementById('chart');
  //         const dataPie = document.getElementById('pie'); 
  //         // Seleziona il container
  //         if (data || dataPie) {

  //           let elementToUse = data || dataPie;

  //             html2canvas(elementToUse,  { 
  //               scale: 2,
  //               backgroundColor: '#1b4d68',
  //               logging: false,
  //               useCORS: true
  //              }).then(canvas => { 

  //                 const imgData = canvas.toDataURL('image/png'); 
  //                 const pdf = new jsPDF('l', 'mm', 'a4'); 



  //                 // const imgWidthCm = 10; 
  //                 // const imgWidth = imgWidthCm * 10; 

  //                 const imgWidth = 160;
  //                 const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //                 const pageWidth = pdf.internal.pageSize.getWidth();
  //                 const xPosition = (pageWidth - imgWidth - 40) / 2; // Sposta leggermente a sinistra per fare spazio ai box
  //                 const yPosition = 20;


  //                 const boxWidth = 30;
  //                 const boxHeight = 22;
  //                 const boxRadius = 2;


  //     /* -------------------------------Chart Image-------------------------------------------------------- */

  //                 pdf.setFillColor(27, 77, 104);
  //                 pdf.roundedRect( xPosition, yPosition, imgWidth, imgHeight + 20, boxRadius, boxRadius, 'F');
  //                 pdf.addImage(imgData, 'PNG', xPosition, yPosition + 10, imgWidth, imgHeight);




  //     /* -------------------------------Toolbar Numero e Percentuale -------------------------------------- */    
  //                 pdf.setFont('helvetica', 'bold');
  //                 pdf.setFontSize(24);
  //                 pdf.setTextColor(255, 255, 255); 
  //                 pdf.text("10  ", xPosition + 18, yPosition + 18) ;


  //                 pdf.setFont('helvetica', 'normal');
  //                 pdf.setFontSize(10);
  //                 pdf.setTextColor(255, 255, 255); 
  //                 pdf.text("+200.00% ", xPosition + 30, yPosition + 18) ;


  //                 // Aggiungi l'icona arrow-up



  //    /* -------------------------------Titolo------------------------------------------------------------ */
  //                 pdf.setFont('helvetica', 'normal');
  //                 pdf.setFontSize(18);
  //                 pdf.setTextColor(255, 255, 255); 
  //                 pdf.text("Clienti Acquisti Ultimi 3 Mesi", xPosition + 10, yPosition + 25);

  //    /* ---------------------------------------------Ciclo For Per il tooltip ----------------------------------------------- */

  //    if (this.acquiredCostumer.items && this.acquiredCostumer.items.length > 0) {
  //     const boxStartX = xPosition + imgWidth - 45; // Posizione i box sulla destra

  //     this.acquiredCostumer.items.forEach((item: any, index: number) => {
  //       const boxY = yPosition + 30 + (index * (boxHeight + 5));

  //       // Box bianco
  //       pdf.setFillColor(255, 255, 255);
  //       pdf.roundedRect(boxStartX, boxY, boxWidth, boxHeight, boxRadius, boxRadius, 'F');

  //       // Testo nel box
  //       pdf.setFont('helvetica', 'bold');
  //       pdf.setFontSize(9);
  //       pdf.setTextColor(27, 77, 104);
  //       pdf.text(`Clienti: ${item.nrProcedure}`, boxStartX + 3, boxY + 5);

  //       pdf.setFont('helvetica', 'normal');
  //       pdf.setFontSize(8);
  //       pdf.text(`Anno: ${item.Anno}`, boxStartX + 3, boxY + 10);
  //       pdf.text(`Mese: ${item.desMese}`, boxStartX + 3, boxY + 15);

  //       const trendValue = item.trend !== undefined ? `${item.trend}%` : '%';
  //       pdf.text(`Trend: ${trendValue}`, boxStartX + 3, boxY + 20);
  //     });
  //   }



  // /* --------------------------------------- Tooltip 1 ---------------------------------------- */

  //                 // pdf.setFillColor(255, 255, 255);
  //                 // pdf.roundedRect( xPosition + 128, yPosition + 16, boxWidth, boxHeight, boxRadius, boxRadius, 'F'); // valore margin botton fisso = "2" - yPosition + 16 è di partenza
  //                 // pdf.setFont('helvetica', 'bold');
  //                 // pdf.setFontSize(10);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Clienti: 2", textX + 21, xPosition + 32); //valore margin bottom fisso ="4"
  //                 // pdf.setFont('helvetica', 'normal');
  //                 // pdf.setFontSize(8);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Anno: 2024", textX + 22, xPosition + 36);
  //                 // pdf.text("Mese: Dicembre", textX + 22, xPosition + 40);
  //                 // pdf.text("Trend: %", textX + 22, xPosition + 44);           


  // /* ---------------------------------------Tooltip 2 Fatto ---------------------------------------- */

  //                 // pdf.setFillColor(4255, 255, 255);
  //                 // pdf.roundedRect( xPosition + 128, yPosition + 44, boxWidth, boxHeight, boxRadius, boxRadius, 'F');

  //                 // pdf.setFont('helvetica', 'bold');
  //                 // pdf.setFontSize(10);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Clienti: 2", textX + 21, xPosition + 60);

  //                 // pdf.setFont('helvetica', 'normal');
  //                 // pdf.setFontSize(8);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Anno: 2025", textX + 22, xPosition + 64);
  //                 // pdf.text("Mese: Gennaio", textX + 22, xPosition + 68);
  //                 // pdf.text("Trend: 0.00%", textX + 22, xPosition + 72);

  // /*!! ---------------------------------------Tooltip 3 Fatto---------------------------------------- */

  //                 // pdf.setFillColor(255, 255, 255);
  //                 // pdf.roundedRect( xPosition + 128, yPosition + 72, boxWidth, boxHeight, boxRadius, boxRadius, 'F');
  //                 // pdf.setFont('helvetica', 'bold');
  //                 // pdf.setFontSize(10);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Clienti: 6", textX + 21 , xPosition + 88);
  //                 // pdf.setFont('helvetica', 'normal');
  //                 // pdf.setFontSize(8);
  //                 // pdf.setTextColor(27, 77, 104);
  //                 // pdf.text("Anno: 2025", textX + 22, xPosition + 92);
  //                 // pdf.text("Mese: Febbraio", textX + 22, xPosition + 96);
  //                 // pdf.text("Trend: 200.00%", textX + 22, xPosition + 100);



  // /* --------------------------------------- Salvataggio pdf ---------------------------------------- */
  //                 pdf.save('grafico.pdf'); 
  //             });
  //         } else {
  //             console.error('Elemento chart non trovato');
  //         }
  //     }, 0);
  // }

  generatePdf() {


    setTimeout(() => {

      this.activeButton = 0;

      const container = document.querySelector('.container__chart');

      if (!container) {
        console.error('Container del grafico non trovato');
        return;
      }


      const containerClone = container.cloneNode(true) as HTMLElement; //Utilizza as HTMLElement per il casting di tipo in TypeScript

      // Remove the button group as it shouldn't appear in the PDF
      const buttonGroupClone = containerClone.querySelector('#buttonGroup');
      if (buttonGroupClone) {
        buttonGroupClone.remove();
      }

      // const lineChartDescription = containerClone.querySelector('.lineChart__description');
      // if (lineChartDescription) {
      //   lineChartDescription.remove();
      // }

      // Create a temporary container with specific styling
      const tempContainer = document.createElement('div');
      tempContainer.style.cssText = `
      position: absolute;
      left: -9999px;
      background-color: rgb(27, 77, 104);
      width: 570px;
      padding: 20px 0;
      border-radius: 12px;
    `;
      tempContainer.appendChild(containerClone);
      document.body.appendChild(tempContainer);

      // Configure html2canvas options
      const html2canvasOptions = {
        scale: 2,
        backgroundColor: '#1b4d68',
        logging: false,
        useCORS: true,
        onclone: (document, element) => {
          const el = element as HTMLElement;
          // Ensure proper height and visibility
          el.style.height = 'auto';
          el.style.overflow = 'visible';

          // Enhance text visibility
          const textElements = el.querySelectorAll('text, .lineChart__toolbar-title, .lineChart__toolbar-icon');
          textElements.forEach(elem => {
            (elem as HTMLElement).style.fill = '#ffffff';
            (elem as HTMLElement).style.color = '#ffffff';
          });
        }
      };

      html2canvas(containerClone, html2canvasOptions).then(canvas => {
        // Clean up the temporary container
        document.body.removeChild(tempContainer);

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4'
        });

        // Calculate dimensions
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Set image width to 75% of page width
        const imgWidth = pageWidth * 0.75;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Center the image
        const xPosition = (pageWidth - imgWidth) / 2;
        const yPosition = (pageHeight - imgHeight) / 2;

        // Add background rectangle
        pdf.setFillColor(27, 77, 104);
        pdf.roundedRect(xPosition - 5, yPosition - 5, imgWidth + 10, imgHeight + 10, 3, 3, 'F');

        // Add the main chart image
        pdf.addImage(imgData, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

        // Add data boxes on the right if they exist
        // if (this.acquiredCostumer && this.acquiredCostumer.items) {
        //   const boxStartX = xPosition + imgWidth + 10;
        //   const boxWidth = 40;
        //   const boxHeight = 25;
        //   const boxSpacing = 5;

        //   this.acquiredCostumer.items.forEach((item: any, index: number) => {
        //     const boxY = yPosition + (index * (boxHeight + boxSpacing));

        //     // White background box
        //     pdf.setFillColor(255, 255, 255);
        //     pdf.roundedRect(boxStartX, boxY, boxWidth, boxHeight, 2, 2, 'F');

        //     // Text content
        //     pdf.setTextColor(27, 77, 104);
        //     pdf.setFont('helvetica', 'bold');
        //     pdf.setFontSize(10);
        //     pdf.text('Clienti: ' + (item.nrProcedure || ''), boxStartX + 3, boxY + 5);

        //     pdf.setFont('helvetica', 'normal');
        //     pdf.setFontSize(8);
        //     pdf.text('Anno: ' + (item.Anno || ''), boxStartX + 3, boxY + 10);
        //     pdf.text('Mese: ' + (item.desMese || ''), boxStartX + 3, boxY + 15);
        //     const trendValue = item.trend ? item.trend.toFixed(2) + '%' : '';
        //     pdf.text('Trend: ' + trendValue, boxStartX + 3, boxY + 20);
        //   });
        // }

        pdf.save('grafico.pdf');
      });
    }, 100);
  }
  // changeChartType(type: string) {

  //   this.currentChartType = type;
  //   console.log('tipo di grafico avviato', type);

  //   const opzioniComuniSerie = {
  //     argumentField: "desMese",  
  //     valueField: "nrProcedure"
  //   };


  //   if (type === 'pie') {
  //     return;
  //   }else if (type === 'bar') {
  //     this.chart.instance.option({
  //       series: [{
  //         type: 'bar',
  //         ...opzioniComuniSerie,
  //         showInLegend: false,
  //         color: '#ffffff',
  //         border: {
  //           visible: true,
  //           color: '#ffffff',
  //           width: 2
  //         }
  //       }],
  //       commonSeriesSettings: {
  //         color: '#ffffff',
  //         barPadding: 0.1,
  //         backgroundColor: '#ffffff'
  //       }
  //     });
  //   } else {
  //     // Grafico a linee (default)
  //     this.chart.instance.option({
  //       series: [{
  //         type: 'line',
  //         color: '#ffffff',
  //         showInLegend: false,
  //         ...opzioniComuniSerie,
  //         point: {
  //           visible: true,
  //           color: '#1b4d68',
  //           size: 8,
  //           border: {
  //             color: '#ffffff',
  //             visible: true,
  //             width: 2
  //           }
  //         }
  //       }]
  //     });


  //   // Assicurati che il grafico si ridisegni correttamente
  //   this.chart.instance.refresh();
  // } }

  // Aggiungi questo metodo per le etichette personalizzate

  private capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }



}

